import domReady from "@wordpress/dom-ready";

domReady(() => {
    const galleries = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-vendor-posts .celebrate-vendor-posts-slideshow");

    galleries.forEach((gallery) => {
        const parent = gallery.closest('.wp-block-celebrate-suite-celebrate-vendor-posts');
        if (parent) {
            const navigation = parent.getAttribute('data-navigation') === 'true';
            const pagination = parent.getAttribute('data-pagination') === 'true';
            const autoplay = parent.getAttribute('data-autoplay') === 'true';
            const autoplaySpeed = parseInt(parent.getAttribute('data-autoplay-speed')) || 4000;
            const groupCells = parent.getAttribute('data-group-cells') === 'true';
            const centerMode = parent.getAttribute('data-center-mode') === 'true';

            const flkty = new Flickity(gallery, {
                cellAlign: centerMode ? "center" : "left",
                contain: true,
                draggable: true,
                wrapAround: true,
                percentPosition: false,
                autoPlay: autoplay ? autoplaySpeed : false,
                prevNextButtons: navigation ? true : false,
                pageDots: pagination ? true : false,
                groupCells: groupCells,
                on: {
                    ready: function() {
                        gallery.style.opacity = 1;
                    }
                }
            });
        }
    });
});
